<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header";
import UserShowDetails from "@/views/pages/account/profile/user-show-details.vue";
import { Storage } from 'aws-amplify';
//import ProfileImageUploader from "../../../../components/widgets/ProfileImageUploader.vue";
import ProfileImageUploader from "../../../../components/ProfileImageUploader.vue";
//import UserEditDetails from "@/views/pages/account/profile/user-edit-details.vue";

export default {
    data() {
        return {
            title: "User Profile",
            items: [
                {
                    text: "Profile",
                },
            ],
            reloadProfileImage: 0,
            user: {
                name: null,
                email: null,
                phone_number: null,
                password: null,
                confirmPassword: null,
                profileSrc: null,
            },
            selectedComponent: 'UserShowDetails',
        };
    },
    methods: {
       
        async loadedProfileSrc(value) {
            this.user.profileSrc = value != null && value != '' ? await Storage.get(value, { level: "protected"}) : require('@/assets/images/img-profile-placeholder.png');
            this.reloadProfileImage++;
        },
    },
    beforeRouteEnter(to, from, next) {
        const toastData = to.query.toastData;
        if (toastData) {
            next((vm) => {
                if(toastData.type) vm.$toast.showToast(toastData.type, toastData.title, toastData.message);
            });
        } else {
            next();
        }
    },
    components: {
        Layout,
        ProfileImageUploader,
        PageHeader,
        UserShowDetails,
        //UserEditDetails,
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" />
        <p>The user profile is a collection of settings and information associated with you and your business. It includes critical information such as user details, business details, and business address.</p>
        <div class="card">
              <div class="card-body">
                  <div class="row">
                      <div class="col-sm-3 col-md-3 col-lg-3 profile-uploader-col">
                                 <profile-image-uploader
                                    :key="reloadProfileImage"
                                    :profileImageSrc="user.profileSrc"
                                    label="Profile Photo"
                                    :isRequired="false"
                                    :showUploadButton="false"
                                    :showDeleteButton="false"
                                />
                      </div>
                      <div class="col-sm-9 col-md-9 col-lg-9">
                          <component :is='selectedComponent' @profile-src-loaded='loadedProfileSrc'></component>
                          <div class="row mt-3">
                              <div class="col-sm-9 col-md-9 col-lg-9">
                                  <router-link to="/pages/profile/edit/password">Change Your Password</router-link>
                              </div>
                              <div class="col-sm-3 col-md-3 col-lg-3">
                                <router-link to="/pages/profile/edit">
                                  <button class="btn btn-primary ps-5 pe-5" type="button">
                                      Edit Profile
                                  </button>
                                </router-link>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              
          </div>
          
    </Layout>
    
</template>

<style>
.pointer {
    cursor: pointer;
}

.card-active {
    background-color: #ffa549 !important;
}

.card-img-back {
    background-color: #f1f0f9;
}

.profile-uploader-col {
  width: 280px; 
}
/* @media (max-width: 991px) {
   .card {
    flex-direction: column; 
  }

  .profile-uploader-col {
    width: 100%; 
    text-align: center; 
  }

  .col-content {
    width: 100%; 
  }
  .col-md-6 {
    width: 100%; 
  }
} */

</style>
